import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Site from "./components/Site";
import Dashboard from "./components/home/Dashboard";
import Setup from "./components/home/Setup";
import Login from "./components/login/Login";

import Brands from "./components/brands/Brands";
import BrandAdd from "./components/brands/BrandAdd";
import BrandUpdate from "./components/brands/BrandUpdate";
import BrandDetails from "./components/brands/BrandDetails";

import MainCategories from "./components/main-category/MainCategories";
import MainCategoryAdd from "./components/main-category/MainCategoryAdd";
import MainCategoryUpdate from "./components/main-category/MainCategoryUpdate";
import MainCategoryDetails from "./components/main-category/MainCategoryDetails";

import SubCategories from "./components/sub-category/SubCategories";
import SubCategoryAdd from "./components/sub-category/SubCategoryAdd";
import SubCategoryUpdate from "./components/sub-category/SubCategoryUpdate";
import SubCategoryDetails from "./components/sub-category/SubCategoryDetails";

import Products from "./components/product/Products";
import ProductAdd from "./components/product/ProductAdd";
import ProductUpdate from "./components/product/ProductUpdate";
import ProductDetails from "./components/product/ProductDetails";

import SizeMaster from "./components/product/size/SizeMaster";
import ColorMaster from "./components/product/color/ColorMaster";

import Coupons from "./components/coupons/Coupons";
import CouponAdd from "./components/coupons/CouponAdd";
import CouponUpdate from "./components/coupons/CouponUpdate";
import CouponDetails from "./components/coupons/CouponDetails";

import Orders from "./components/orders/Orders";
import OrderPlaced from "./components/orders/pages/OrderPlaced";
import OrderConfirmed from "./components/orders/pages/OrderConfirmed";
import OrderCanceled from "./components/orders/pages/OrderCanceled";
import OrderDelivered from "./components/orders/pages/OrderDelivered";
import OrderDetails from "./components/orders/pages/OrderDetails";

import Design from "./components/product/design/Design";
import DesignUpdate from "./components/product/design/DesignUpdate";
import DesignDetails from "./components/product/design/DesignDetails";

import RateDiary from "./components/rate-diary/RateDiary";
import RateDiaryAdd from "./components/rate-diary/RateDiaryAdd";
import RateDiaryDetails from "./components/rate-diary/RateDiaryDetails";
import RateDiaryEdit from "./components/rate-diary/RateDiaryEdit";

import Agent from "./components/agent/Agent";
import AgentAdd from "./components/agent/AgentAdd";
import AgentUpdate from "./components/agent/AgentUpdate";
import AgentDetails from "./components/agent/AgentDetails";
import AgentOrder from "./components/agent/agentorder/AgentOrder";
import AgentOrderDetails from "./components/agent/agentorder/AgentOrderDetails";

import AgentRetailer from "./components/agent/agent_retailer/AgentRetailer";
import AgentRetailerAdd from "./components/agent/agent_retailer/AgentRetailerAdd";
import AgentRetailerUpdate from "./components/agent/agent_retailer/AgentRetailerUpdate";
import AgentRetailerDetails from "./components/agent/agent_retailer/AgentRetailerDetails";

import Retailer from "./components/retailer/Retailer";
import RetailerAdd from "./components/retailer/RetailerAdd";
import RetailerUpdate from "./components/retailer/RetailerUpdate";
import RetailerDetails from "./components/retailer/RetailerDetails";
import RetailerOrder from "./components/retailer/RetailerOrder";
import RetailerOrderDetails from "./components/retailer/RetailerOrderDetails";
import RateDiaryList from "./components/rate-diary/RateDiaryList";

import PlaceOrder from "./components/placeorder/PlaceOrder";
import AddPlaceOrder from "./components/placeorder/AddPlaceOrder";
import PlaceOrderDetails from "./components/placeorder/PlaceOrderDetails";
import BarcodeList from "./components/product/design/BarcodeList";

import Wallet from "./components/retailer/wallet/Wallet";
import WalletAdd from "./components/retailer/wallet/WalletAdd";
import WalletUpdate from "./components/retailer/wallet/WalletUpdate";
import WalletHistory from "./components/retailer/wallet/WalletHistory";

import GenerateBarcode from "./components/product/barcode/GenrateBarcode";
import OrderShipped from "./components/orders/pages/OrderShipped";
import BarcodeListPrint from "./components/rate-diary/BarcodeListPrint";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Route for login at root and /login */}
        <Route path="/" element={<Login />} />
        {/* <Route path="/login" element={<Login />} /> */}

        {/* Nested routes under Site */}
        <Route path="/" element={<Site />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/add" element={<BrandAdd />} />
          <Route path="/brands/update" element={<BrandUpdate />} />
          <Route path="/brands/details" element={<BrandDetails />} />

          <Route path="/main-categories" element={<MainCategories />} />
          <Route path="/main-categories/add" element={<MainCategoryAdd />} />
          <Route
            path="/main-categories/update"
            element={<MainCategoryUpdate />}
          />
          <Route
            path="/main-categories/details"
            element={<MainCategoryDetails />}
          />

          <Route path="/sub-categories" element={<SubCategories />} />
          <Route path="/sub-categories/add" element={<SubCategoryAdd />} />
          <Route
            path="/sub-categories/update"
            element={<SubCategoryUpdate />}
          />
          <Route
            path="/sub-categories/details"
            element={<SubCategoryDetails />}
          />

          <Route path="/products" element={<Products />} />
          <Route path="/products/add" element={<ProductAdd />} />
          <Route path="/products/update" element={<ProductUpdate />} />
          <Route path="/products/details" element={<ProductDetails />} />

          <Route path="/products/designs" element={<Design />} />
          <Route path="/products/designs/details" element={<DesignDetails />} />
          <Route path="/products/designs/update" element={<DesignUpdate />} />
          <Route
            path="/products/designs/genrated-barcode"
            element={<BarcodeList />}
          />

          <Route path="/products/size" element={<SizeMaster />} />
          <Route path="/products/color" element={<ColorMaster />} />

          <Route
            path="/products/genrate-barcode"
            element={<GenerateBarcode />}
          />

          {/* <Route path="/rate-diary" element={<RateDiary />} /> */}
          <Route path="/rate-diary/list" element={<RateDiaryList />} />
          <Route path="/rate-diary/add" element={<RateDiaryAdd />} />
          <Route path="/rate-diary/details" element={<RateDiaryDetails />} />
          <Route path="/rate-diary/update" element={<RateDiaryEdit />} />
          <Route
            path="/rate-diary/genrated-barcode"
            element={<BarcodeListPrint />}
          />

          <Route path="/place-order" element={<PlaceOrder />} />
          <Route path="/place-order/add" element={<AddPlaceOrder />} />
          <Route path="/place-order/details" element={<PlaceOrderDetails />} />

          <Route path="/coupons" element={<Coupons />} />
          <Route path="/coupons/add" element={<CouponAdd />} />
          <Route path="/coupons/update" element={<CouponUpdate />} />
          <Route path="/coupons/details" element={<CouponDetails />} />

          <Route path="/setup" element={<Setup />} />

          <Route path="/retailer" element={<Retailer />} />
          <Route path="/retailer/add" element={<RetailerAdd />} />
          <Route path="/retailer/update" element={<RetailerUpdate />} />
          <Route path="/retailer/details" element={<RetailerDetails />} />
          <Route path="/retailer/orders" element={<RetailerOrder />} />
          <Route
            path="/retailer/orders-details"
            element={<RetailerOrderDetails />}
          />

          <Route path="/retailer/credit-wallet" element={<Wallet />} />
          <Route path="/retailer/wallet-add" element={<WalletAdd />} />
          <Route path="/retailer/wallet-history" element={<WalletHistory />} />
          <Route path="/retailer/wallet-update" element={<WalletUpdate />} />

          <Route path="/agent" element={<Agent />} />
          <Route path="/agent/agent-add" element={<AgentAdd />} />
          <Route path="/agent/agent-update" element={<AgentUpdate />} />
          <Route path="/agent/agent-details" element={<AgentDetails />} />
          <Route path="/agent/agent-order" element={<AgentOrder />} />
          <Route
            path="/agent/agent-order-details"
            element={<AgentOrderDetails />}
          />
          <Route path="/agent/agent-retailer" element={<AgentRetailer />} />
          <Route
            path="/agent/agent-add-retailer"
            element={<AgentRetailerAdd />}
          />
          <Route
            path="/agent/agent-update-retailer"
            element={<AgentRetailerUpdate />}
          />
          <Route
            path="/agent/agent-details-retailer"
            element={<AgentRetailerDetails />}
          />

          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/placed" element={<OrderPlaced />} />
          <Route path="/orders/confirmed" element={<OrderConfirmed />} />
          <Route path="/orders/shipped" element={<OrderShipped />} />
          <Route path="/orders/cancelled" element={<OrderCanceled />} />
          <Route path="/orders/delivered" element={<OrderDelivered />} />
          <Route path="/orders/details" element={<OrderDetails />} />
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
